<template>
  <div id="footer" class="acea-row">
    <!-- <router-link
      :to="item.url"
      class="item"
      :class="{ on: item.url === $route.path }"
      v-for="(item, index) in footerList"
      :key="index"
    >
      <div
        class="iconfont"
        :class="item.icon1 + ' ' + (item.url === $route.path ? item.icon2 : '')"
      ></div>
      <div>{{ item.name }}</div>
    </router-link> -->
    <!-- <div class="footer"> -->
      <div class="footer-item" v-for="item in foot_list" @click="goCate(item.id,item.is_area)">{{item.title}}</div>
    <!-- </div> -->
  </div>
</template>
<script>
import {getNavCate} from "@/api/public.js"
export default {
  name: "Footer",
  props: {},
  inject:['app'],
  data: function() {
    return {
      foot_list:[]
    };
  },
  mounted(){
    this.getNavCate();
  },
  methods: {
    getNavCate:function(){
      getNavCate().then(res=>{
        this.foot_list = res.data.list;
      });
    },
    goCate:function(id,is_area){
      if(is_area){
         this.$router.push({ path: "/area/list",query: { pid: id }});
      }else{
        this.$router.push({ path: "/cate/list",query: { pid: id } });
      }
      let history_name = this.$router.history.current.name;
      this.app.reload();
    }
  }
};
</script>
<style scoped>
  .footer{
    display: flex;
  }
  .footer-item{
    flex: 1;
    text-align: center;
    padding: 0 .4rem ;
    line-height: 1rem;
    font-family: "楷体";
    font-size: .3rem;
    color: #911D1D;
    background: #EEE5C8;
    font-weight: bold;
  }
  .footer-item~.footer-item{
    border-left: 1px solid #f0f0f0;
  }
</style>
